// extracted by mini-css-extract-plugin
export default {"root":"PhotoCard__root--1zg5E","photoWrapper":"PhotoCard__photoWrapper--1KQly","imageContainer":"PhotoCard__imageContainer--3I5Iv","photo":"PhotoCard__photo--10G6h"};